<template>
  <v-app>
    <v-content >
      <v-container fluid text-xs-center pa-0>
        <v-layout row wrap justify-center align-center>
          <v-flex   xs12 sm12 md11 lg7 >
            <router-view style="background-color: #fff"></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

  //this is saved
  /*
   window.questionsAnswer
window.calibrationAnswers
   */


import NavBar from './components/Navbar.vue';
export default {
  name: 'app',
  components: {
      NavBar
  }
}

</script>
<style scoped>
  .body-all-container{
    background-color: rgba(255, 255, 255, 0.9);
    padding: 60px 40px;
  }
  @media (max-width: 599px){
    .body-all-container{
      padding: 20px 0 0;
    }
  }
</style>




// WEBPACK FOOTER //
// src/App.vue